import React from 'react';
import { DropdownItem } from '@atlaskit/dropdown-menu';
import { type Integration } from '../../types';
import { useIntegrationComponents } from '../ThirdParty';

interface OwnProps {
	integration: Integration;
	onClick: (event: React.MouseEvent | React.KeyboardEvent) => void;
}

const ConnectIntegrationMenuItem: React.FC<OwnProps> = ({ integration, onClick }) => {
	const { icon, connectButtonText } = useIntegrationComponents(integration);
	return (
		<DropdownItem testId={`${integration}-connect-menu-item`} elemBefore={icon} onClick={onClick}>
			{connectButtonText}
		</DropdownItem>
	);
};

export default ConnectIntegrationMenuItem;
